module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "fm-head"
  }, [_vm._v("INTRODUCTION")]), _vm._v(" "), _c('div', {
    staticClass: "image"
  }, [_c('p', {
    staticClass: "image-center"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/P11-1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('i', [_vm._v("Public domain.")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Pullman is the name of a man, a company, a town (today a Chicago neighborhood) and a type of railroad sleeping car. The very name brings to mind luxurious accommodations on Pullman cars and identifies the porters who served in those rail cars, as well as the first major railroad strike and near nationwide boycott. The story of this man, his company and his company town encompasses important segments in the history of urban planning, industrial efficiency, labor/management conflict and race and gender relations.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("More than 160 years ago, George Mortimer Pullman realized that many railroad passengers would pay extra for comfort. He built luxurious passenger cars with comfortable, private sleeping accommodations and attentive service. He made a fortune.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In 1880, he consolidated his operations by building an attractive town with a modern industrial complex, row homes and apartments for his employees and commercial buildings to serve their needs. Not liking to relinquish control of his products, he, through his company, maintained ownership of the town’s housing and commercial buildings, as well as the thousands of Pullman sleeper cars that they made.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8d1163e0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Introduction.vue
// module id = 75
// module chunks = 0